define('modules/domain_listing/index',['require','exports','module','base/router','./views/main','common/views/dashboard_layout','common/collections/domains'],function (require, exports, module) {
  'use strict';

  var Router = require('base/router'),
    DomainListingView = require('./views/main'),
    DashboardLayout = require('common/views/dashboard_layout'),
    DomainListingCollection = require('common/collections/domains');

  module.exports = function (moduleManager) {
    var ModuleRouter = Router.extend({
      routes: {
        'domains(/)': 'index',
        'domains/help': 'help',
      },
      activateDomainTab: function () {
        $('.ed-navlink.active').removeClass('active');
        $('.js-domains').addClass('active');
      },
      beforeAll: function () {
        var domainListingCollection = new DomainListingCollection(),
          dashboard = moduleManager.showInstance(DashboardLayout),
          domainListing = new DomainListingView({ collection: domainListingCollection });
        this.activateDomainTab();
        dashboard.showLoading();
        //just in case we came from pages
        dashboard.$top.close();
        return { dashboard: dashboard, domainListing: domainListing };
      },
      index: function (args, data) {
        var views = args;
        if (data) {
          views = data;
        }

        views.domainListing.collection.fetch({
          reset: true,
          success: function () {
            views.dashboard.$content.show(views.domainListing);
          },
        });
      },

      help: function (views) {
        views.domainListing.domainHelp();
      },
    });

    return new ModuleRouter();
  };
});

